import SimpleBar from "simplebar-react";
import { Col, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import classnames from "classnames";
import FoodMenuTab from "./tabContent/foodMenuTab";

import EventDetails from "./tabContent/eventDetails";
import {
  foodPreOrderEventData,
  foodPreOrderEventGuestData,
} from "../../../../../store/foodPreOederEvent/action";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";

const EventGuest = ({ eventUserData, branding }) => {
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      foodPreOrderEventGuestData(
        { id: eventUserData?.data?.FoodPreOrderEventGuest_Id },
        params?.token
      )
    );
  }, []);
  const { foodPreOrderEventGuestDataAPI, foodPreOrderEventGuestDataLoading } =
    useSelector((state) => ({
      foodPreOrderEventGuestDataAPI:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestData
          ?.foodpreordereventguest_data,
      foodPreOrderEventGuestDataLoading:
        state.FoodPreOrderEventReducer.foodPreOrderEventGuestDataLoading,
    }));
  const Tabs = [
    {
      id: "1",
      name: "Event Details",
    },
    {
      id: "2",
      name: "Food Menu",
    },
  ];
  const [activeTab, setActiveTab] = React.useState("1");
  useEffect(() => {
    dispatch(
      foodPreOrderEventData(
        { id: eventUserData?.data?.FoodPreOrderEvent_Id },
        params?.token
      )
    );
  }, [eventUserData]);
  const { foodPreOrderEventDataAPI } = useSelector((state) => ({
    foodPreOrderEventDataAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventData,
  }));

  const [availableFoodMenu, setAvailableFoodMenu] = useState([]);
  console.log("availableFoodMenu", availableFoodMenu);
  useEffect(() => {
    if (isEmpty(foodPreOrderEventDataAPI)) return;
    setEventDetails(foodPreOrderEventDataAPI?.foodpreorderevent_data);
  }, [foodPreOrderEventDataAPI]);
  useEffect(() => {
    if (isEmpty(foodPreOrderEventGuestDataAPI)) return;
    setAvailableFoodMenu(foodPreOrderEventGuestDataAPI?.foodmenu_list);
  }, [foodPreOrderEventGuestDataAPI]);

  const [eventDetails, setEventDetails] = useState([]);
  return (
    <div
      style={{
        background: branding?.PortalCssColourDivBackground,
      }}
    >
      {/* Task 24837 - the logo was capped at 300x300, which on a phone is
          most of the first screen before any content. */}
      {branding?.LogoUrl && (
        <div className="text-center mb-3">
          <img
            src={branding.LogoUrl}
            alt="logo"
            className="guest-eventpage__logo"
          />
        </div>
      )}

      <div className="text-center mb-4">
        <h2
          className="guest-title"
          style={{ fontFamily: branding?.PortalCssFontFamilyDivHeading }}
        >
          Welcome {foodPreOrderEventGuestDataAPI?.FullName}
        </h2>
      </div>

      {/* Task 24837 - segmented pills instead of default Bootstrap nav-tabs,
          matching the tab control the staff side uses. Real <button>s: the
          old ones were anchors with href="#", which a keyboard cannot use
          properly and which put a stray hash on the URL of a page whose URL
          is a one-time token. */}
      <div className="guest-tabs mb-4" role="tablist">
        {Tabs.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={activeTab === item.id}
            className={classnames("guest-tab", {
              "guest-tab--active": activeTab === item.id,
            })}
            onClick={() => setActiveTab(item.id)}
          >
            {item.name}
          </button>
        ))}
      </div>

      <div>
        <div>
          {activeTab === "1" && (
            <EventDetails
              eventDetails={eventDetails}
              eventUserData={eventUserData}
              branding={branding}
              setActiveTab={setActiveTab}
            />
          )}
          {activeTab === "2" && (
            <FoodMenuTab
              foodPreOrderEventDataAPI={foodPreOrderEventDataAPI}
              availableFoodMenu={availableFoodMenu}
              eventDetails={eventDetails}
              eventUserData={eventUserData}
              branding={branding}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EventGuest;
